import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Priority' },
    { value: 2, label: 'Notes' },
    { value: 3, label: 'Allowed Access' },
    { value: 4, label: 'Receives SMS' },
    { value: 5, label: 'Bill Payer' },
    { value: 6, label: 'Relationship' },
    { value: 7, label: 'Medical Start Date' },
    { value: 8, label: 'Medical End Date' },
    { value: 8, label: 'Permission to contact' },
  ],
});
